import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { usePreviousLocationContext } from "../../../helpers/PreviousLocationContext";
import useDecodedToken from "../../../hooks/userHooks/useDecodedToken";
import useFetchOtherUserInfos from "../../../hooks/userHooks/useFetchOtherUserInfos";
import { changeCurrentUserWithFeeds } from "../../../redux/feeds/feedsSlice";
import { AppDispatch, StoreState } from "../../../redux/store";
import CurrentUserProfilePage from "./CurrentUserProfilePage";
import OtherUserProfilePage from "./OtherUserProfilePage";

type Props = {
  username: string;
};

function ProfileWrapper({ username }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const collectionTab = searchParams.get("ctc");
  const { connectedUsername, role, sourceId } = useDecodedToken();
  const { otherUser: user } = useFetchOtherUserInfos(username);
  const previousLocation = usePreviousLocationContext();
  const [comingFromPayment, setComingFromPayment] = useState(sessionStorage.getItem("payment-page") === "True" || false);
  const dispatch = useDispatch<AppDispatch>();
  const { currentUserWithFeeds } = useSelector((state: StoreState) => state.feeds);

  useEffect(() => {
    if (user?.id && user.id !== currentUserWithFeeds) {
      dispatch(changeCurrentUserWithFeeds(user?.id));
    }
  }, [user?.id]);

  useEffect(() => {
    if (previousLocation?.pathname) {
      if (previousLocation.pathname.includes("/payment") || previousLocation.pathname.includes("/subscribe")) {
        setComingFromPayment(true);
      } else if (!previousLocation.pathname.includes("/p/")) {
        sessionStorage.setItem("profilePageReferrer", previousLocation.pathname + (previousLocation.search || ""));
      }
    }
  }, [previousLocation]);

  const handleNavigate = () => {
    localStorage.removeItem("activeProfileTab");
    
    if (comingFromPayment && !collectionTab) {
      const referrer = sessionStorage.getItem("profilePageReferrer");
      sessionStorage.removeItem("profilePageReferrer");
      sessionStorage.removeItem("payment-page");

      if (referrer) {
        navigate(referrer, { replace: true });
      } else {
        navigate("/common/discover", { replace: true });
      }
    } else if (collectionTab && comingFromPayment) {
      navigate(-3);
    } else {
      navigate(-1);
    }
  };

  //TODO: Oussama loader ??
  // if (!user?.id) {
  //   return (
  //     <div style={{ height: "100dvh", display: "flex", alignItems: "center", justifyContent: "center" }}>
  //       <></>;
  //     </div>
  //   );
  // }

  if (connectedUsername === username) {
    return <CurrentUserProfilePage />;
  } else {
    return <OtherUserProfilePage username={username} handleNavigate={handleNavigate} currentUserRole={role} currentUserId={sourceId} />;
  }
}

export default ProfileWrapper;
